module.exports = __webpack_public_path__ + "img/nav-05.abd0c426.jpg";